import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  usuarios: [],
  usuario: {},	
  error: "", // for error message
  loading: false,
  errorMsg: false, // for error
  colorMsg: "",
  exito: false,

};

const usuariosSlice = createSlice({
  name: "usuarios",
  initialState,
  reducers: {


    apiError(state, action) {
      state.error = action.payload;
      state.loading = false;
      state.errorMsg = true;
      state.colorMsg = "danger";
    },
    usuariosSuccess(state, action) {
      state.usuarios = action.payload.data.data;
      state.loading = false;
      state.errorMsg = false;
      state.error = action.payload.data.message;
      state.colorMsg = "success";
      state.exito = false;
    },
    usuarioSuccess(state, action) {
      state.usuario = action.payload.data.data;
      state.loading = false;
      state.errorMsg = true;
      state.colorMsg = "success";
      state.error = action.payload.data.message;
      state.exito = true;
    },
    usuariosDeleteSuccess(state, action) {
      state.usuarios = state.usuarios[0] 
        ? [state.usuarios[0].filter(u => u.id !== action.payload.data.data?.id), state.usuarios[1] - 1]
        : state.usuarios;
      state.error = action.payload.data.message;
      state.loading = false;
      state.errorMsg = true;
      state.colorMsg = "success";
      state.exito = true;
    },
    reset_usuario_flag(state) {
      state.success = false;
      state.error = "";
      state.loading = false;
      state.errorMsg = false;
      state.colorMsg = "";
    },
  },
});

export const {
  apiError,
  usuariosSuccess,
  usuarioSuccess,
  usuariosDeleteSuccess,
  reset_usuario_flag,
} = usuariosSlice.actions;

export default usuariosSlice.reducer;
